import { lazy } from 'react';

export const CustomFieldsPage = lazy(() => import('./CustomFieldsSettingsPage'));
